import { render, staticRenderFns } from "./AdmissionsMovieYear.vue?vue&type=template&id=a3628246"
import script from "./AdmissionsMovieYear.vue?vue&type=script&lang=js"
export * from "./AdmissionsMovieYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pforret/Code/Movix/laravel/showtimes.movix/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a3628246')) {
      api.createRecord('a3628246', component.options)
    } else {
      api.reload('a3628246', component.options)
    }
    module.hot.accept("./AdmissionsMovieYear.vue?vue&type=template&id=a3628246", function () {
      api.rerender('a3628246', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Admissions/AdmissionsMovieYear.vue"
export default component.exports